// 合并所有reducer 并且返回
import { combineReducers } from "redux";
import { selectedLabel } from "./selectedLabel";
import { paintItems } from "./paintItems";
import { lastAction } from "./lastAction";
import { inputFocus } from "./inputFocus";
import { regionList } from "./regionList";
import { platform } from "./platform";
import { dimension } from "./dimension";


import { channel } from "./channel";
import { region } from "./region";

export default combineReducers({ 
	channel,
	region,
	inputFocus,
	dimension,

	selectedLabel, 
	paintItems, 
	lastAction, 
	regionList, 
	platform,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js